var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2319_3161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9772 11.6646C15.8977 11.6646 16.6439 10.9184 16.6439 9.99792C16.6439 9.07745 15.8977 8.33125 14.9772 8.33125C14.0567 8.33125 13.3105 9.07745 13.3105 9.99792C13.3105 10.9184 14.0567 11.6646 14.9772 11.6646Z",
    fill: "#84B0DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 11.6687C10.9206 11.6687 11.6668 10.9226 11.6668 10.0021C11.6668 9.08161 10.9206 8.33542 10.0002 8.33542C9.07969 8.33542 8.3335 9.08161 8.3335 10.0021C8.3335 10.9226 9.07969 11.6687 10.0002 11.6687Z",
    fill: "#84B0DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.02311 11.6646C5.94359 11.6646 6.68978 10.9184 6.68978 9.99792C6.68978 9.07745 5.94359 8.33125 5.02311 8.33125C4.10264 8.33125 3.35645 9.07745 3.35645 9.99792C3.35645 10.9184 4.10264 11.6646 5.02311 11.6646Z",
    fill: "#84B0DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 1.66667C11.6482 1.66667 13.2593 2.15541 14.6298 3.07109C16.0002 3.98676 17.0683 5.28825 17.699 6.81097C18.3297 8.33369 18.4948 10.0092 18.1732 11.6258C17.8517 13.2423 17.058 14.7271 15.8926 15.8926C14.7271 17.058 13.2423 17.8517 11.6258 18.1732C10.0092 18.4948 8.33369 18.3297 6.81098 17.699C5.28826 17.0683 3.98677 16.0002 3.07109 14.6298C2.15541 13.2593 1.66667 11.6482 1.66667 10C1.66667 7.78986 2.54464 5.67025 4.10745 4.10744C5.67025 2.54464 7.78987 1.66667 10 1.66667ZM10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17316C0.00433286 8.00043 -0.193701 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8078C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C20 7.34783 18.9464 4.8043 17.0711 2.92893C15.1957 1.05357 12.6522 0 10 0V0Z",
    fill: "#84B0DA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2319_3161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/Icon-4.c12ebf2987423efbbe0a4639f69c93bc.svg";
export { ForwardRef as ReactComponent };